import createStore from "zustand";
import persist from "../utils/persist";

const useAuthStore = createStore(
  persist(
    {
      key: "principally_auth",
      denylist: ["isLoading", "errorMessage"],
    },
    (set) => ({
      isLoading: false,
      errorMessage: "",
      auth: { token: null },
      setAuth: (auth) => {
        set((state) => ({
          auth: { token: auth },
        }));
      },

      clearAuth: () => {
        set((state) => ({
          auth: { token: null },
        }));
      },
    })
  )
);

export default useAuthStore;
